import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_DiagnosticOrderForServices = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_DiagnosticOrderForServices' className='file-pdf-document'>

            <div className='file-template'>

                <h4>Non-Intensive Outpatient Services</h4>
                <p className='w-750'>
                    <input type="checkbox" name="cbDiagnosticAssessment1" id="cbDiagnosticAssessment1" className='add-only' value="Diagnostic Assessment/Psychiatric Tx/Med Administration Admission Criteria" />
                    <strong>Diagnostic Assessment/Psychiatric Tx/Med Administration Admission Criteria, </strong>90833, 99201, 99202, 99203, 99204, 99205, 99211, 99212, 99213, 99214, 99215, 90791, 90792, 96372:
                </p>
                <p className='w-750'>
                    <span className='small'><strong>(may include all modifiers and all practitioner levels)</strong></span>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Individual has a mental illness or a substance-related disorder and has
                            recently entered the service system
                        </li>
                        <li>Individual is in need of annual assessment and re-authorization of
                            Service array; or
                        </li>
                        <li>Individual has been prescribed medications as a part of the treatment array or has a confounding medical issue
                            which interact with behavioral health dx, requiring medical oversight; or
                        </li>
                        <li>Individual has a need of an assessment due to a change in clinical/functional status.
                        </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbDiagnosticAssessment" id="cbDiagnosticAssessment" className='add-only' value="Diagnostic Assessment/Psychiatric Tx/Med Administration Admission Criteria" />
                    <strong>Nursing Assessment & Care Admission Criteria</strong> T1001,T1002, T1003, 96150 96151, 96156:
                </p>
                <p className='w-750'>
                    <span className='small'><strong>(may include all modifiers and all practitioner levels)</strong></span>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Individual presents symptoms that are likely to respond to medical/
                            Nursing interventions; or
                        </li>
                        <li>Individual has been prescribed medications as a part of the treatment
                            Array or has a confounding medical condition
                        </li>
                    </ul>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Ordered By:</span>
                            <input type="text" name="txtOrderedBy" id="txtOrderedBy" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Ordered:</span>
                            <input type="date" name="txtDateOrdered" id="txtDateOrdered" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-275'>&nbsp;</td>
                        <td className='signature w-275'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-275'>Signature</td>
                        <td className='small w-275'>Credentials</td>
                        <td className='small w-200'>Date</td>
                    </tr>
                </table>



            </div>
        </form>

    )
} 
